import React from 'react';
import {
  View,
  TouchableOpacity,
  Image,
  StyleSheet
} from 'react-native';

import Colors from '../../constants/Colors';

const WritePostButton = ({ onPress, imageSource }) => {
  return(
    <View
      style={styles.absoluteStyle}
      pointerEvents='box-none'
    >
      <View style={styles.toBottomStyle}>
        <TouchableOpacity
          style={styles.touchableStyle}
          onPress={onPress}
        >
          <Image
            style={styles.imageStyle}
            source={imageSource}
            resizeMode={'contain'}
          />
        </TouchableOpacity>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  absoluteStyle: {
    height: '100%',
    width: '100%',
    flex: 1,
    position: 'absolute',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  toBottomStyle: {
    flex: 1,
    position: 'absolute',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  touchableStyle: {
    height: 64,
    width: 64,
    backgroundColor: Colors.backgroundColor,
    borderWidth: 0,
    borderRadius: 45,
    marginBottom: 20,
    marginRight: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageStyle: {
    height: 42,
    width: 42,
  }
});

export default WritePostButton;
